import React, { forwardRef, useCallback } from 'react';
import { FieldTypes, urlRegexValidator } from 'utils/formUtils';
import GenericPullCredentialsForm from '../GenericPullCredentialsForm';
import BlackDuckMappingForm from './BlackDuckMappingForm';
import { useFeatureFlag } from "contexts/FeatureFlagContext";

const BlackDuckCredentialsForm = forwardRef((props, ref) => {
    const featureFlags = useFeatureFlag();

    const fields = [
        {
            name: "apiEndpoint",
            label: "Blackduck Hub Endpoint",
            rules: [{
                required: true,
                message: "Endpoint is required"
            }, urlRegexValidator()]
        },
        {
            name: "token",
            label: "Token",
            required: true,
            type: FieldTypes.PASSWORD,
        },...(featureFlags.MANAGE_SBOM ? [{
                    name: "ingestSBOM",
                    label: "Ingest Components",
                    type: FieldTypes.SWITCH,
                    help: 'Ingest all components from the projects mapped under this configuration into the Supply Chain module',
                    inline: true,
                  }] : []),
    ];

    const parseExtraFields = useCallback((config) => {
            return {
                ...config,
                ingestSBOM : config.ingestSBOM === "true"
            };
        }, [])

    return (
        <GenericPullCredentialsForm 
         {...props} 
         ref={ref}
         fields={fields}
         toolDisplayName="Blackduck Hub"
         MappingForm={BlackDuckMappingForm}
         initialValue={{ingestSBOM: false}}
         parseExtraFields={parseExtraFields}
          />
    )
});

export default BlackDuckCredentialsForm;
